import { useState } from "react";
import { NavLink } from "react-router-dom";
import Icon from "components/general/Icon";
import { BiArrowToRight } from "react-icons/bi";
import COLORS from "constants/Colors";
import getClassNames from "utils/getClassName";
import Navbar from "components/general/Navbar";
import { NavigationListItem } from "./types";
import styles from "./styles.module.scss";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";

export default function SidebarLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { hasPermissionTo } = usePermissions();

  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const contentStyle = {
    paddingInlineStart: isOpen ? "161px" : "50px",
    transition: "padding-inline-start 300ms ease-in-out",
  };

  const toggleBtnClassName = getClassNames([
    "shadow-sm",
    `${styles["toggle-btn"]}`,
    `${isOpen ? styles.open : ""}`,
  ]);

  const rawNavigationList: NavigationListItem[] = [
    {
      title: "Dashboard",
      iconName: "home",
      href: "/",
      permission: "view_dashboard",
    },
    {
      title: "Reports",
      iconName: "reports",
      href: "/reports",
      permission: "view_reports",
    },
    {
      title: "Request",
      iconName: "note",
      href: "/requests",
      permission: "view_requests",
    },
    {
      title: "Calendar",
      iconName: "calendar",
      href: "/calendar",
      permission: "view_calendar",
    },
    {
      title: "Shifts",
      iconName: "note",
      href: "/shifts",
      permission: "view_shift_assignment",
    },
    {
      title: "Staff Directory",
      iconName: "users",
      href: "/staff-directory",
      permission: "view_staff_directory",
    },
    {
      title: "Activity",
      iconName: "active-note",
      href: "/activity",
      permission: "view_activity",
    },
    {
      title: "Settings",
      iconName: "setting",
      href: "/settings",
    },
    {
      title: "Integration",
      iconName: "integration",
      href: "/integration",
    },
  ];

  const navigationList = filterByPermissions(
    rawNavigationList,
    hasPermissionTo,
  );
  console.log("perrrrrrrrrr", navigationList);
  return (
    <div className="h-100">
      <Navbar />

      <aside className={`${styles.sidenav} ${isOpen ? styles.open : ""}`}>
        <button
          className={toggleBtnClassName}
          onClick={toggleSidebar}
          type="button"
          title="toggle sidebar"
        >
          <BiArrowToRight size={21} color={COLORS.info} />
        </button>

        <div className={`w-100 ${styles.navigationContent}`}>
          {navigationList.map((item) => (
            <NavLink
              key={item.title}
              to={item.href}
              className={({ isActive }) => (isActive ? styles.active : "")}
            >
              {({ isActive }) => (
                <>
                  <div className={styles.activeVerticalBar} />
                  <Icon
                    name={item.iconName}
                    size={24}
                    color={isActive ? "primary" : "info"}
                  />
                  <span className={isOpen ? styles.open : ""}>
                    {item.title}
                  </span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </aside>

      <main className={styles.sidelayoutContent} style={contentStyle}>
        {children}
      </main>
    </div>
  );
}
